import { render, staticRenderFns } from "./BrothersKaramazovArticle.vue?vue&type=template&id=52b4fe63&"
import script from "./BrothersKaramazovArticle.vue?vue&type=script&lang=js&"
export * from "./BrothersKaramazovArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports